import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import checkCircleTokens from "@amzn/meridian-tokens/base/icon/check-circle";
import sparklesLargeTokens from "@amzn/meridian-tokens/base/icon/sparkles-large";
import CitationText from "src/components/shared/citationText/citationText";
import NoSaigeAnswerMessage from "src/components/shared/noSaigeAnswerMessage/NoSaigeAnswerMessage";
import SourcesDropdown from "src/components/shared/sourcesDropDown/sourcesDropdown";
import { processCitations } from "src/utils/citationUtils";
import { QuestionPreview as Preview } from "../types";
import Chip from "./chip";

/**
 * Renders a candidate question's answer exactly as the chat page renders a
 * policy answer, with the retrieval verdict added above it. Same no-answer
 * rule as chatResult: an attribution only counts as cited when it carries text
 * segments.
 */
const QuestionPreview = ({ preview }: { preview: Preview }) => {
  const hasCitedDocument = (preview.sourceAttributions ?? []).some(
    (attribution) => (attribution.textMessageSegments?.length ?? 0) > 0,
  );
  const isNoAnswer = !preview.relatedDocuments?.length || !hasCitedDocument;

  return (
    <div className="admin-report__preview">
      {preview.expectedCited ? (
        <Chip tone="green" tokens={checkCircleTokens}>
          The file is listed in the returned sources
        </Chip>
      ) : (
        /* The verdict carries its own consequence and instruction, so the
           failing chip is a block rather than a pill. */
        <Chip tone="red" tokens={alertTokens} block>
          <span className="admin-report__chip-stack">
            <span className="admin-report__chip-heading">
              The file is not in the returned sources
            </span>
            <span className="admin-report__chip-note">
              We should not save this question, because the next run would fail
              it too. Rephrase it and test again until the file comes back in
              the sources.
            </span>
          </span>
        </Chip>
      )}

      <Row spacing="200" spacingInset="none none 100 none">
        <Icon tokens={sparklesLargeTokens} color="success" />
        <Text type="h100">SAIGE</Text>
      </Row>

      <div className="user-bot-response">
        {isNoAnswer ? (
          <NoSaigeAnswerMessage />
        ) : (
          <>
            <CitationText
              text={processCitations(
                preview.llmMessage,
                preview.sourceAttributions,
              )}
              citations={preview.sourceAttributions}
            />
            {preview.relatedDocuments && (
              <SourcesDropdown
                relatedDocuments={preview.relatedDocuments}
                sourceAttributions={preview.sourceAttributions}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionPreview;
